import React from 'react';
import styled from 'styled-components';

const CustomNumberBlock = styled.span`
    font-size:  ${props => props.fontSize || '14px'};
    font-family: Montserrat,sans-serif;
    font-weight: ${props => props.fontWeight || '400'};
    margin-left: ${props => props.marginLeft || '0px'};
    color:  ${props => props.color || '#111'};
    text-decoration: ${props => props.isCancle ? 'line-through' : ''}; 
`;

const CustomNumber = ({ value, isPrice, fontSize, fontWeight, color, marginLeft, isCancle, unitfontSize, unitfontWeight}) => {

    let numberValue = isPrice ? value * 1 : value;
    let unitFontSize = unitfontSize? unitfontSize: fontSize;
    let unitFontWeight = unitfontWeight? unitfontWeight:fontWeight;
    return (
        isPrice?
        <CustomNumberBlock fontSize={fontSize}
            fontWeight={fontWeight} color={color}
            marginLeft={marginLeft}
            isCancle={isCancle}>
                {Number(numberValue.toFixed(1)).toLocaleString()}
                <span style={{fontSize:unitFontSize, fontWeight:unitFontWeight}}>원</span>
        </CustomNumberBlock>
        :

        <CustomNumberBlock fontSize={fontSize}
            fontWeight={fontWeight} color={color}
            marginLeft={marginLeft}
            isCancle={isCancle}>
            {numberValue}
        </CustomNumberBlock>
    );
};

export default CustomNumber;